module.exports = __webpack_public_path__ + "static/quaals_feather_token_whip-732f90b51c43a83a3734766a011519fc.jpeg";